import React, { useEffect, useState } from 'react';
import axios from 'axios';

const TimeSyncChecker = ({ children }) => {
  const [timeMismatch, setTimeMismatch] = useState(null); // null = checking, false = ok, true = mismatch

  useEffect(() => {
    const checkTimeSync = async () => {
      try {
        const response = await axios.post(`${process.env.REACT_APP_URL}api/others/checkTime`);
        const serverTime = new Date(response.data.result);
        const clientTime = new Date();
        // const clientTime = new Date('2025-05-28T05:54:00.000Z');
        const diffInSeconds = Math.abs((clientTime - serverTime) / 1000);
        if (diffInSeconds > 60) {
          setTimeMismatch(true);
        } else {
          setTimeMismatch(false);
        }
      } catch (error) {
        console.error("Failed to fetch server time", error);
        setTimeMismatch(false); // fallback to rendering app in case of failure
      }
    };

    checkTimeSync();
  }, []);

  if (timeMismatch === null) return null; // Don't render anything while checking

  return (
    <div style={{ position: 'relative' }}>
      {children}

      {timeMismatch && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '20px',
            fontWeight: 'bold',
            textAlign: 'center',
            padding: '20px',
          }}
        >
          ⚠️ Your system time appears to be incorrect. <br />
          To use this website, please adjust your clock.
        </div>
      )}
    </div>
  );
};

export default TimeSyncChecker;

